// extracted by mini-css-extract-plugin
export default {"related":"MakePage-module--related--2821f","favouriteButton":"MakePage-module--favouriteButton--a995c","favouriteButtonContainer":"MakePage-module--favouriteButtonContainer--04f56"};